import { ReadingText } from "./type.app.js";

const SINGLE_LETTER = /^[a-zA-Z]$/;

export const displayReadingText = (text: ReadingText): string => {
  if (text.kind !== "letter") return text.text;
  const raw = text.text.trim();
  if (!SINGLE_LETTER.test(raw)) return text.text;
  const lower = raw.toLowerCase();
  return `${lower.toUpperCase()}\u00A0${lower}`;
};
